module.exports = __webpack_public_path__ + "img/galeria-forrajeras-1.9dab0ff1.jpg";